import { apiFetch } from "@/utils";

function getParameterByCode(code) {
  return apiFetch("parameter?code=" + code);
}

export default { getParameterByCode }
export { getParameterByCode }



// WEBPACK FOOTER //
// ./src/utils/param.js